module.exports = __webpack_public_path__ + "img/25.3bd9ff99.jpg";